import { render } from "./NewQcConfiguration.vue?vue&type=template&id=677145c4"
import script from "./NewQcConfiguration.vue?vue&type=script&lang=js"
export * from "./NewQcConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__